import { viewerFragment, featureFragment } from 'common/fragments'
import { searchMasterFragment } from 'common/fragments/www'
import gql from 'graphql-tag'

const roomFragment = `
  id
  uid
  name
  capacity
  pageTitle
  thumbnails(perPage: 1) {
    results {
      ... on Thumbnail {
        url
        description
      }
    }
  }
  prices {
    minText
    minUnitText
    maxText
    maxUnitText
  }
  space {
    id
    username
    stateText
    city
  }
  owner {
    id
    rank
  }
  hasDirectReservationPlans
  hasLastMinuteDiscountPlans
`

export const VIEWER_QUERY = gql`
{
  viewer {
    ${viewerFragment}
    favorites(page: 1, perPage: 3) {
      results {
        favorable {
          ... on Room {
            ${roomFragment}
          }
        }
      }
    }
  }
}`

export const PAGE_QUERY = gql`
{
  ${searchMasterFragment}
  feature(uid: "top_matome") {
    uid
    items(perPage: 4 page:1) {
      results {
        ... on Feature {
          ${featureFragment}
        }
      }
    }
  }
  eventTypes(rentType: DAY_TIME) {
    results {
      ... on EventType {
        name
        nameText
        roomsCount
      }
    }
  }
  topics {
    results {
      ... on Topic {
        uid
        title
        image
        themeColor
      }
    }
  }
  stayEventTypes:eventTypes(rentType: STAY) {
    results {
      ... on EventType {
        name
        nameText
        roomsCount
      }
    }
  }
  classRooms: search(page: 1, perPage: 3, eventType: "class", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  partyRooms: search(page: 1, perPage: 3, eventType: "party", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  photoRooms: search(page: 1, perPage: 3, eventType: "photo_shoot", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  filmRooms: search(page: 1, perPage: 3, eventType: "film_shoot", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  sportsRooms: search(page: 1, perPage: 3, eventType: "sports", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  performanceRooms: search(page: 1, perPage: 3, eventType: "performance", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  studioRooms: search(page: 1, perPage: 3, eventType: "studio", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  officeRooms: search(page: 1, perPage: 3, eventType: "office", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  weddingRooms: search(page: 1, perPage: 3, eventType: "wedding", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  eventRooms: search(page: 1, perPage: 3, eventType: "event", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  stayRooms: search(page: 1, perPage: 3, eventType: "stay", rentType: STAY) {
    results {
      ${roomFragment}
    }
    pageInfo {
      totalCount
    }
  }
  otherRooms: search(page: 1, perPage: 3, eventType: "other", rentType: DAY_TIME) {
    results {
      ${roomFragment}
    }
  }
  countRooms: search(page: 1, perPage: 1, rentType: DAY_TIME) {
    pageInfo {
      totalCount
    }
  }
}`



// WEBPACK FOOTER //
// ./src/containers/pages/HomePage/graphql.js